import { Container } from "./styles";

const Input = ({ label, register, name, error, ...rest }: any) => {
  return (
    <Container>
      <div>
        {label} {!!error && <span className="error">- {error}</span>}
      </div>
      <input {...register(name)} {...rest} />
    </Container>
  );
};

export default Input;
